import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center"
          data-testid="error-boundary-fallback"
          onClick={() => window.location.reload()}
          role="button"
          tabIndex={0}
        >
          <div className="text-4xl">⚠️</div>
          <h1 className="font-display text-xl font-medium">Something went wrong.</h1>
          <p className="text-sm text-muted-foreground">Tap to refresh.</p>
          <button
            className="mt-2 rounded-md bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground"
            onClick={(e) => { e.stopPropagation(); window.location.reload(); }}
            data-testid="error-boundary-refresh-btn"
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
